import { ExpanderComponentProps } from "react-data-table-component";
import { TrailRequestDataType } from "./TrailRequestListDatas.type";

export const CustomExpandableComponent: React.FC<ExpanderComponentProps<TrailRequestDataType>> = ({ data }) => {
    return (
        <div>
            <p>First Name: {data.first_name}</p>
            <p>Last Name: {data.last_name}</p>
            <p>Email: {data.email}</p>
            <p>Company Name: {data.company_name}</p>
            <p>Mobile Number: {data.mobile_number}</p>
        </div>
    );
};
